import { Typography } from "neetoui";
import { isEmpty } from "ramda";
import { useTranslation, Trans } from "react-i18next";
import { useFavoriteStore } from "stores/useFavoriteStore";

import { NoDataMessage } from "./common";
import { MAX_RATING } from "./constants";

const Favorites = () => {
  const favorites = useFavoriteStore.pickFrom();
  const { t } = useTranslation();
  if (isEmpty(favorites)) {
    return <NoDataMessage message={t("message.favoritesEmpty")} />;
  }

  return (
    <div className="m-auto w-2/3 pt-16">
      <div className="mt-4 max-h-[70vh] overflow-y-auto px-4">
        {favorites.map(({ title, imdbId, rating }) => (
          <div
            className="mb-3 flex items-center justify-between rounded border bg-white p-4 shadow"
            key={imdbId}
          >
            <Typography style="body1" weight="bold">
              {title}
            </Typography>
            <Typography className="text-gray-500" style="body2" weight="medium">
              <Trans
                components={{ span: <span className="font-bold text-black" /> }}
                i18nKey="labels.rating"
                values={{ rating, MAX_RATING }}
              />
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Favorites;
